import React, { useEffect, useRef } from 'react';
import '../styles/Modal.css'; // Suppose que vous avez un fichier de styles pour les modales

interface FacturePreviewModalProps {
  show: boolean;
  handleClose: () => void;
  pdfData?: string | null; // Modifié pour accepter string ou null
  invoiceData?: any; // Données de la facture pour information (optionnel)
}

const FacturePreviewModal: React.FC<FacturePreviewModalProps> = ({
  show,
  handleClose,
  pdfData, // Doit être une Blob URL ou quelque chose qu'un iframe peut lire
  invoiceData, // Exemple
}) => {

  // Révoquer l'URL de l'objet lorsque la modale se ferme pour libérer la mémoire
  useEffect(() => {
    return () => {
      if (pdfData && typeof pdfData === 'string') { // Si c'est une URL d'objet
        URL.revokeObjectURL(pdfData);
      }
    };
  }, [pdfData]);

  if (!show) {
    return null;
  }

  return (
    <div className="pdf-modal-overlay"> {/* Utilisez les classes similaires à Devis.tsx */}
      <div className="pdf-modal-content"> {/* Utilisez les classes similaires à Devis.tsx */}
        <div className="pdf-modal-header"> {/* Utilisez les classes similaires à Devis.tsx */}
          <h2>Aperçu Facture {invoiceData?.id ? `#${invoiceData.id}` : ''}</h2> {/* Affichez le numéro de facture si dispo */}
          <button className="close-btn" onClick={handleClose}> {/* Utilisez les classes similaires à Devis.tsx */}
            &times;
          </button>
        </div>
        <div className="modal-body"> {/* Vous pouvez garder ou adapter cette classe */}
          {pdfData ? (
            <iframe
              src={pdfData} // L'URL du Blob ou une URL statique
              title="Aperçu Facture PDF"
              width="100%"
              height="600px"
              style={{ border: "none" }}
            />
          ) : (
            <p>Génération du PDF en cours ou données non disponibles.</p>
          )}
        </div>
        <div className="pdf-modal-footer"> {/* Utilisez les classes similaires à Devis.tsx */}
          <button onClick={handleClose} className="button">Fermer</button>
          {/* Bouton de téléchargement similaire à Devis.tsx */}
           {pdfData && typeof pdfData === 'string' && ( // Si pdfData est une URL d'objet
            <a 
              href={pdfData} 
              download={`Facture_${invoiceData?.id || 'sans_nom'}.pdf`} 
              className="download-btn" // Utilisez les classes similaires à Devis.tsx
            >
              Télécharger PDF
            </a>
           )}
        </div>
      </div>
    </div>
  );
};

export default FacturePreviewModal; 